import React from 'react';

const ReitsPage = () => {

    return (


        <embed src="https://blueviolet-viper-967204.builder-preview.com/" type="website" />


    );
};

export default ReitsPage;